export const getUrl = (path) => {
  return `${window.location.origin}/${path}`;
}